module.exports = __webpack_public_path__ + "img/double_bubble_layout_1.cb0008a0.svg";